document.addEventListener("DOMContentLoaded", function () {
  const footer = document.getElementById("footer-fixed-bottom");
  const backToTopBtn = document.getElementById("back-to-top-btn");

  window.addEventListener("scroll", function () {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const shouldShow = screen.width < 1100 && scrollTop > 20;
    footer && (footer.style.display = shouldShow ? "flex" : "none");
  });

  if (backToTopBtn) {
    backToTopBtn.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
